import styled from 'styled-components';
/**
 * A `Tabs.Panels` component is the parent of a set of `Tabs.Panel` components
 * and a child of a [`Tabs`](#/More%20components?id=tabs) component.
 * **This component should not be used on its own.**
 *
 * @since 8.10.0
 */

var TabPanels = /*#__PURE__*/styled.div.withConfig({
  displayName: "TabPanels",
  componentId: "c11n-8-64-0__sc-1vlts3l-0"
})([""]);
TabPanels.displayName = 'Tabs.Panels';
/** @component */

export default TabPanels;
export var StyledTabPanels = TabPanels;